import * as Yup from 'yup';
import PhoneNumber from 'awesome-phonenumber';
import { getNumberValidation, getRequiredMessage } from 'views/declarations/utils/validation-utils';

const companyValidateSchema = Yup.object().shape({
    deferredAccountNumber: Yup.string().nullable(),
    name: Yup.string().required(getRequiredMessage('name')).nullable(),
    contact: Yup.object().shape({
        email: Yup.string().required(getRequiredMessage('email')).email('Not a valid email format!').nullable(),
        // Country code is required when we have a phone number
        phoneCountryCode: Yup.string()
            .nullable()
            .test('phoneCountryCode-required', 'Phone country code is required', function (value) {
                const { phoneNumber } = this.parent as {
                    phoneNumber?: number | null;
                };

                if (phoneNumber != null) {
                    return !!value;
                }

                return true;
            }),
        // Phone number is required when we provide a country code
        phoneNumber: getNumberValidation()
            .nullable()
            .test('phoneNumber-valid', 'Phone number is required', function (value?: number | null) {
                const { phoneCountryCode } = this.parent as {
                    phoneCountryCode?: string | null;
                };

                if (!phoneCountryCode && value == null) return true;
                if (!phoneCountryCode) return true;
                if (value == null) return true;

                // Validate real number
                const phoneNumber = new PhoneNumber(`${phoneCountryCode}${value}`);
                if (!phoneNumber.isValid()) {
                    return this.createError({
                        message: 'Phone number is invalid',
                    });
                }

                return true;
            }),
    }),
    eori: Yup.string().nullable(),
    address: Yup.object().shape({
        addressLine1: Yup.string().required(getRequiredMessage('addressLine1')).nullable(),
        postCode: Yup.string().required(getRequiredMessage('postCode')).nullable(),
        city: Yup.string().required(getRequiredMessage('city')).nullable(),
        country: Yup.string().required(getRequiredMessage('country')).nullable(),
    }),
});

export default companyValidateSchema;
